/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetCashReserveSelfOptions,
  GetCashReserveSelfResponses,
} from '../types/GetCashReserveSelf'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Returns the user's available Global Account USD balance alongside their minimum cash reserve requirement and its breakdown. While available_usd is below required_usd the user may not open new leveraged positions, submit buy orders, transfer assets out of their Global Account or withdraw.
 * @summary Get the minimum USD cash reserve requirement for the logged in user
 * {@link /v1/accounts/self/cash_reserve}
 */
export function getCashReserveSelf<ThrowOnError extends boolean = true>(
  options: Options<GetCashReserveSelfOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetCashReserveSelfResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/accounts/self/cash_reserve',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetCashReserveSelfResponses, ThrowOnError>>,
  )
}
